<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { slightBorder, link } = $AppState.theme.colors;
</script>

<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="12" cy="12" r="10" fill={slightBorder} />
  <path
    d="M16 9L10.5 15L8 12.2727"
    stroke={link}
    stroke-width="1.5"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
